import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-remove-account-name-warning-dialog',
  templateUrl: './remove-account-name-warning-dialog.component.html',
  styleUrls: ['./remove-account-name-warning-dialog.component.scss'],
})

export class RemoveAccountNameWarningDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<RemoveAccountNameWarningDialogComponent>
  ) {}
  

  onClick(action: string): void | string {
    if (action === 'confirm') {
      this.dialogRef.close('confirm');
    } else if (action === 'cancel') {
      this.dialogRef.close('Canceled by user');
    }
  }
}
